export function cleanQueryFromTagsinputToSearch (query) {
  let str = ''
  let logicWords = ['AND', 'OR', 'NOT']

  if (query === null) {
    return ''
  }

  query = query.replace(/(^,+|,+$)/mg, '').replace('–', '-').split(',')

  query.forEach((tag) => {
    tag = tag.trim()
    if (tag.match(/"[\w\s]+"/g) === null && tag.match(/[\w]+/gm) !== null && tag.indexOf('name:') === -1 &&
      typeof logicWords.find((logicWord) => logicWord === tag) === 'undefined') {
      str = (str !== '') ? str + ' AND "' + tag + '" ' : '"' + tag + '" '
    } else {
      str += tag + ' '
    }
  })

  return str.replace(/\sAND\s+AND\s/g, ' AND ').replace(/\sOR\s+AND\s/g, ' OR ')
    .replace(/\sNOT\s+AND\s/g, ' NOT ').replace(/\sOR\s+OR\s/g, ' OR ')
    .replace(/\s\s+/g, ' ').trim()
}

export function formatSearchForUrl (query) {
  let logicWords = ['AND', 'OR', 'NOT']

  let tmpQuery = query.split(/"\s|\s"/gm)

  tmpQuery = tmpQuery.map((element) => {
    if (element.indexOf('name:') === -1 && element.indexOf('title:') === -1 && element.indexOf('abstract:') === -1) {
      element = element.replace(/"/gm, '')
    } else {
      let tmp = element.slice(-1)
      if (tmp !== '"') {
        element = element + '"'
      }
    }

    if (logicWords.findIndex((word) => {
      return element.toUpperCase() === word
    }) !== -1) {
      element = element.toUpperCase()
    }

    return element
  })

  return tmpQuery.join(',')
}



// WEBPACK FOOTER //
// ./src/assets/scripts/search.js